<!-- eslint-disable vue/no-mutating-props -->
<script setup lang="ts">
import type { SiteBlock } from '~/types/types'

defineProps<{ block: SiteBlock }>()
</script>

<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <UFormField label="Title">
    <UInput
      v-model="block.data.title"
      class="w-full"
    />
  </UFormField>
  <p class="text-xs ui-text-subtle">
    Shows your bookable staff with live availability.
  </p>
</template>
